module.exports = __webpack_public_path__ + "static/media/president-suite-img7.9d7a859c.jpg";